export const webSocket = {
  NEW_CHAT: 'NEW_CHAT',
  CHAT_UPDATE: 'CHAT_UPDATE',
  WS_REQUEST_CHAT_MESSAGES: 'WS_REQUEST_CHAT_MESSAGES'
};





// WEBPACK FOOTER //
// ./src/services/chat/chat.constants.ts